enum FeeConditionType {
  SERVICE_OPTION = "service-option",
  ZONE = "zone"
}

export default FeeConditionType;
